import { memo } from 'react';
import dayjs from 'dayjs';
import styled from 'styled-components';

import { HeaderType } from '@utils/types';
import { Product } from '@graphql/types';
import { onImageError } from '@utils/common';

import { TableRow, TableCell } from '@components/share/Table/table.style';
import theme from '@styles/theme';

type ManageProductTableRowType = {
    header: HeaderType[];
    data: Product;
    onDelete: (id: number) => void;
};

const ManageProductTableRow = ({
    header = [],
    data,
    onDelete
}: ManageProductTableRowType) => {
    return (
        <TableRow $default>
            <TableCell $minWidth={header[0].minWidth} $width={header[0].width}>
                {data?.createdAt
                    ? dayjs(data.createdAt).format('YYYY-MM-DD')
                    : '-'}
            </TableCell>
            <TableCell $minWidth={header[1].minWidth} $width={header[1].width}>
                <Image
                    src={data?.img as string}
                    onError={onImageError}
                    alt="상품 사진"
                />
            </TableCell>
            <TableCell $minWidth={header[2].minWidth} $width={header[2].width}>
                {data?.name || '-'}
            </TableCell>
            <TableCell $minWidth={header[3].minWidth} $width={header[3].width}>
                {typeof data?.lastMonthClickCount === 'number'
                    ? data?.lastMonthClickCount.toLocaleString()
                    : '-'}
            </TableCell>
            <TableCell $minWidth={header[4].minWidth} $width={header[4].width}>
                {typeof data?.accClickCount === 'number'
                    ? data?.accClickCount.toLocaleString()
                    : '-'}
            </TableCell>
            <TableCell $minWidth={header[5].minWidth} $width={header[5].width}>
                {data?.url || '-'}
            </TableCell>
            <TableCell $minWidth={header[6].minWidth} $width={header[6].width}>
                {typeof data?.price === 'number'
                    ? data?.price.toLocaleString()
                    : '-'}
            </TableCell>
            <TableCell
                $minWidth={header[7].minWidth}
                $width={header[7].width}
                onClick={() => onDelete(data?.prId as number)}
                $cursor
                $fontColor={theme.colors.deepGrayFontColor}
            >
                삭제
            </TableCell>
        </TableRow>
    );
};

export default memo(ManageProductTableRow);

const Image = styled.img`
    display: block;
    width: 20px;
    height: 20px;
`;
